// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.reporting.accounting.LedgerPostingReportRequest */
/* istanbul ignore next */
@GandalfModel
export class LedgerPostingReportRequest extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	createdByEmployeeId!: number | null;

	@GandalfLabel('Invoice #')
	@GandalfValidator({ max: { max: 999999999999999999, message: 'Invoice # may not be more than 18 digits' } })
	@GandalfProperty({ designType: Number })
	invoiceId!: number | null;

	@GandalfLabel('Posting End Date')
	@GandalfValidator({ notNull: { message: 'Posting End Date is required' } })
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date, isRequired: true })
	ledgerPostingDateEnd!: Date;

	@GandalfLabel('Posting Start Date')
	@GandalfValidator({ notNull: { message: 'Posting Start Date is required' } })
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date, isRequired: true })
	ledgerPostingDateStart!: Date;

	@GandalfConstantDecorator(constants.LedgerType)
	@GandalfProperty({ designType: constants.LedgerType })
	ledgerType!: constants.LedgerType | null;

	@GandalfProperty({ designType: Number })
	locationId!: number | null;

	@GandalfLabel('Payer #')
	@GandalfValidator({ max: { max: 999999999999999999, message: 'Payer # may not be more than 18 digits' } })
	@GandalfProperty({ designType: Number })
	payerId!: number | null;

	@GandalfConstantDecorator(constants.PayerType)
	@GandalfProperty({ designType: constants.PayerType })
	payerType!: constants.PayerType | null;

}
